import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import polygon1 from './polygon-1.svg';
import './ProfileDropdown.css';
import API from '../api/api';
import { clearAuthSession, getActiveRole } from '../utils/authStorage';

export default function ProfileDropdown({ user, email }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const displayName = user || 'User';
  const initials = displayName
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part.charAt(0).toUpperCase())
    .join('') || 'U';

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      await API.post('/auth/logout');
    } catch (err) {
      // Clear local state even if the backend session is already gone.
    }

    clearAuthSession(getActiveRole());
    localStorage.removeItem('result');
    localStorage.removeItem('examSetupComplete');
    localStorage.removeItem('selectedOptionalSections');
    navigate('/login');
  };

  return (
    <div className="profile-wrapper" ref={dropdownRef}>

      {/* Avatar button */}
      <button className={`avatar-shell${open ? ' is-open' : ''}`} onClick={() => setOpen(!open)}>
        <div className="avatar-initials">
          {initials}
        </div>
      </button>

      {/* Dropdown */}
      {open && (
        <>
          <button
            className="profile-backdrop"
            onClick={() => setOpen(false)}
            aria-label="Close profile menu"
          />
          <div className="profile-dropdown">

            {/* Arrow */}
            <div className="box">
              <img className="polygon" alt="" src={polygon1} />
            </div>

            {/* Header */}
            <div className="dropdown-header">
              <div className="dropdown-avatar">
                {initials}
              </div>
              <div className="dropdown-user-info">
                <span className="dropdown-name">{displayName}</span>
                <span className="dropdown-email">{email || 'No email available'}</span>
              </div>
            </div>

            {/* Divider */}
            <div className="dropdown-divider"></div>

            <button className="dropdown-logout" onClick={handleLogout}>
              <div className="dropdown-item-left">
                <div className="item-icon logout-icon">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                    <polyline points="16 17 21 12 16 7"/>
                    <line x1="21" y1="12" x2="9" y2="12"/>
                  </svg>
                </div>
                <span className="item-text logout-text">Logout</span>
              </div>
            </button>

          </div>
        </>
      )}
    </div>
  );
}
